import * as React from "react";
import TablePagination from "@mui/material/TablePagination";
import { ownStore } from "../../../AppOwnState/ownState";
import { ExecuteLayoutEventMethods } from "../../../General/commonFunctions";

export default function FactsPagination(props) {
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  React.useEffect(() => {
    ExecuteLayoutEventMethods([
      {
        exec: "setdataset",
        args: {
          dset: "paginationState",
          data: {
            pageNo: page,
            rowsPerPage: rowsPerPage,
          },
        },
      },
    ]);
  }, [page, rowsPerPage]);

  const getPaginationState = () => {
    const theState = ownStore.getState("paginationState");
    console.log(theState, "paginationstate");
    return theState;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getDevGridState();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getDevGridState();
  };

  const getDevGridState = () => {
    const theState = ownStore.getState("devGridState");
    console.log(theState, "devgridstate");
    return theState;
  };

  return (
    <TablePagination
      component="div"
      count={100}
      page={props?.currentPage ?? page}
      onPageChange={handleChangePage}
      rowsPerPage={props?.rowsPerPage ?? rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
}
